import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <span className="footer__brand">Old Monk<em>Tech</em></span>

        <nav className="footer__links">
          <a href="#hero">Home</a>
          <a href="#products">Products</a>
          <a href="#services">Services</a>
          <a href="#testimonials">Testimonials</a>
          <a href="#contact">Contact</a>
        </nav>

        <span className="footer__copy">
          © {new Date().getFullYear()} Old Monk Tech. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
